const joditConfig = {
  readonly: false,
  height: 500,
  placeholder: "Write your Privacy Policy here...",
  toolbarAdaptive: false,

  buttons: [
    "bold",
    "italic",
    "underline",
    "|",
    "ul",
    "ol",
    "|",
    "font",
    "fontsize",
    "|",
    "paragraph",
    "align",
    "|",
    "link",
    "image",
    "|",
    "source",
    "undo",
    "redo",
    "|",
    "fullsize",
  ],

   style: {
    fontFamily: "'Poppins', Arial, sans-serif",
    color: "#6b7480",
    background: "#fafbff",
  },
};

export default joditConfig;